import { atom } from "recoil";

import { isLandscape } from "lib/isLandscape";

export const screenOrientationState = atom<"landscape" | "portrait">({
  key: "screenOrientationState",
  default: isLandscape() ? "landscape" : "portrait",
});
